import { CustomActions, CustomState } from "@bToC/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import React, { useState } from "react";
import { connect, DispatchProp } from "react-redux";
import { css } from "styled-components";

const accordionStyles = {
    css: css`
        background: transparent;
        margin-bottom: 2rem;
        border: none;
        span {
            color: #046faf;
        }
        button {
            background: transparent !important;
            border: 1px solid black;
        }
        dd {
            border: none;
        }
    `,
};
// Testing
const inputStyles = {
    css: css`
        padding-bottom: 1rem;
        input {
            width: 1.3em;
            height: 1.3em;
            background-color: white;
            border-radius: 50%;
            vertical-align: middle;
            border: 1px solid black;
            -webkit-appearance: none;
            outline: none;
            cursor: pointer;
            margin-right: 1rem;
            &:checked {
                background-color: #046faf;
                border: 1px solid #046faf;
            }
        }
    `,
};

const enum fields {
    serviceDisplayName = "serviceDisplayName",
    serviceType = "serviceType",
    accordionTitle = "accordionTitle",
    services = "services",
}

type ServiceModel = {
    fields: {
        [fields.serviceDisplayName]: string;
        [fields.serviceType]: string;
    };
};

type MyProps = {
    fields: {
        [fields.accordionTitle]: string;
        [fields.services]: ServiceModel[];
    };
};

type Props = MyProps & ReturnType<typeof mapStateToProps> & DispatchProp<CustomActions>;

const ServiceAccordion: React.FC<Props> = ({ dispatch, servicesArr, fields: { services, accordionTitle } }: Props) => {
    const serviceMap = new Map<string, boolean>();

    services.map(service => {
        serviceMap.set(service.fields.serviceType, servicesArr.includes(service.fields.serviceType));
    });

    const toggleServiceMap = (key: string) => {
        serviceMap.set(key, !serviceMap.get(key));
    };

    const filterMap = (serviceMap: Map<string, boolean>) => {
        const filteredArr: string[] = [];
        serviceMap.forEach((value: boolean, key: string) => {
            if (serviceMap.get(key)) {
                filteredArr.push(key);
            }
        });
        return filteredArr;
    };

    return (
        <StyledWrapper>
            <StyledWrapper {...accordionStyles}>
                <Accordion headingLevel={5}>
                    <AccordionSection title={accordionTitle}>
                        {services.map((service, index) => (
                            <StyledWrapper {...inputStyles}>
                                <input
                                    type="checkbox"
                                    onClick={() => {
                                        toggleServiceMap(service.fields.serviceType);
                                    }}
                                />
                                <label>{service.fields.serviceDisplayName}</label>
                            </StyledWrapper>
                        ))}
                    </AccordionSection>
                </Accordion>
            </StyledWrapper>

            <Button
                onClick={() => {
                    dispatch({ type: "Custom/Traditional/AddServices", services: filterMap(serviceMap) });
                }}
                color="#F06907"
                buttonType="outline"
            >
                {" "}
                Submit{" "}
            </Button>
        </StyledWrapper>
    );
};

const mapStateToProps = (state: CustomState) => ({
    servicesArr: state.addServicesReducer.services,
});

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ServiceAccordion),
    definition: {
        group: "Basic",
        icon: "Link",
        fieldDefinitions: [
            {
                name: fields.accordionTitle,
                fieldType: "General",
                editorTemplate: "TextField",
                displayName: "Accordion Title",
                defaultValue: "",
            },
            {
                name: fields.services,
                editorTemplate: "ListField",
                // tab: contentTab,
                getDisplay: ({ fields: { serviceDisplayName } }) => serviceDisplayName || "Services",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: fields.serviceType,
                        editorTemplate: "TextField",
                        displayName: "Service Type",
                        defaultValue: "",
                    },
                    {
                        name: fields.serviceDisplayName,
                        editorTemplate: "TextField",
                        displayName: "Service Display Name",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
